<template>
    <div>
        <!-- Cabeçalho Fixo -->
        <div
            class="border-b sticky top-0 grid grid-cols-[50px_60px_1fr_100px_1fr_150px_100px] gap-4 px-4 py-2 text-xs font-medium text-gray-600">
            <div></div>
            <div>ID</div>
            <div>Item</div>
            <div>Preço</div>
            <div>Categorias</div>
            <div class="text-right">Usuários</div>
            <div v-if="buttons" class="text-right"></div>
        </div>

        <!-- Lista de Itens -->
        <div class="overflow-hidden sm:rounded-md" v-if="showData()">
            <ul role="list" class="divide-y">
                <li v-for="row in dataRows" :key="row.id">
                    <div 
                        class="grid grid-cols-[50px_60px_1fr_100px_1fr_150px_100px] gap-4 px-4 py-4 items-center hover:bg-blue-50 cursor-pointer"
                        :class="(searchSelected(row.id)) ? 'isSelected' : ''"
                        @click="$emit('open:item', row)">
                        
                        <!-- Status -->
                        <div class="flex items-center justify-center">
                            <div v-if="row.status" class="text-xs">
                                <div v-if="row.status === 'active'"
                                    class="text-white bg-lime-600 rounded-full h-3 w-3"></div>
                                <div v-if="row.status === 'inative'"
                                    class="text-white bg-rose-600 rounded-full h-3 w-3"></div>
                            </div>
                        </div>

                        <!-- ID -->
                        <div class="truncate text-xs text-gray-800">{{ row.external_id }}</div>

                        <!-- Item -->
                        <div class="flex items-center gap-2">
                            <div v-if="row.avatar">
                                <Avatar :avatar="row.avatar" size="md" />
                            </div>
                            <div>
                                <div class="text-sm font-medium">{{ row.name }}</div>
                                <!-- <div class="text-xs text-gray-500">{{ row.description }}</div>-->
                            </div>
                        </div>

                        <!-- Preço -->
                        <div class="flex items-center gap-1 text-sm font-medium text-gray-900">
                            <span v-if="row.currency === 'BRL'">R$</span>
                            <span v-else-if="row.currency === 'USD'">U$</span>
                            <span v-else-if="row.currency === 'EUR'">€</span>
                            {{ row.price }}
                        </div>

                        <!-- Categorias -->
                        <div class="flex gap-1 flex-wrap text-xs text-gray-500">
                            <div v-for="(category, index) in row.categories" :key="index">
                                <div v-if="index < 4"
                                    class="border px-2 py-1 rounded-full bg-blue-100 text-blue-600 text-xs">
                                    {{ category.name }}
                                </div>
                                <div v-else-if="index === 4" class="text-xs text-gray-500">...</div>
                            </div>
                        </div>

                        <!-- Usuários -->
                        <div class="flex justify-end gap-1">
                            <div v-for="(user, index) in row.users" :key="index">
                                <div v-if="index < 4">
                                    <Avatar :avatar="user.avatar" size="xs" />
                                </div>
                            </div>
                            <div v-if="row?.users?.length > 4" class="text-xs text-gray-500 self-center">...</div>
                        </div>

                        <!-- Botões -->
                        <div v-if="buttons" class="flex justify-end gap-1">
                            <slot name="buttons" :row="row" />
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <!-- Caso não haja dados -->
        <div v-else>
            <noData />
        </div>
    </div>
</template>



<script>

import { ChevronRightIcon, LockClosedIcon, QuestionMarkCircleIcon } from '@heroicons/vue/24/solid'

export default {
    name: "ListItems",
    props: {
        buttons: {
            type: Boolean,
            required: false,
            default: false,
        },
        dataRows: {
            type: Object,
            required: false
        },
        selected: {
            type: Array,
            required: false
        },

        type: {
            type: String,
            required: false
        },
        

    },
    emits: ['open:item', 'open:item_area', 'open:remove'],

    components: {
        ChevronRightIcon,
        LockClosedIcon,
        QuestionMarkCircleIcon,
    },
    methods: {

        showData() {
            try {
                if (this.dataRows.length) {
                    return true;
                }
                return false
            } catch (e) {
                return false;
            }
        },
        processAttribute(key, attribute) {
            return this.$Attributs.process(key, attribute);
        },
        searchSelected(id) {
            return this.selected.indexOf(id) > -1;
        },
        nivel(nivel) {
            let seta = '├';
            if (nivel && nivel > 0) {
                for (let i = 1; i <= nivel; i++) {
                    seta = seta + '─';
                }
                seta = seta + '›';
            }
            else {
                seta = '•';
            }
            return seta
        }
    },
    created() {

    },

}


</script>

<style scoped>
.isSelected {
    @apply bg-blue-600;
}
</style>